export default __webpack_public_path__ + "static/media/Beef.3238b8a2.jpg";